<template>
    <div>
        <div class="card">
            <Toolbar class="mb-4">
                <template slot="left">
                    <label>ENVIAR FACTURAS AL SRI</label>
                </template>
            </Toolbar>
			<br>
			<Toolbar class="mb-4">
                <template slot="left">
					<div class="p-fluid p-formgrid p-grid">
						<div class="p-field col-md-2">
							<label for="anio">Año</label>
							<Dropdown id="anio" 
								style="width:120px;"
								:filter="false" 
								:options="anioLista" 
								v-model="anioSeleccionado"
								optionLabel="anio" 
								dataKey="id"
								placeholder="Seleccionar Año">
							</Dropdown>
						</div>
						<div class="p-field col-md-2" style="margin-left: 10px">
							<label for="mes">Mes</label>
							<Dropdown id="mes" 
								style="width:120px;"
								:filter="false" 
								:options="mesLista" 
								v-model="mesSeleccionado"
								optionLabel="mes" 
								dataKey="id"
								placeholder="Seleccionar Mes">
							</Dropdown>
						</div>
						<div class="p-field col-md-2" style="margin-left: 10px">
							<label for="buscar">&nbsp;&nbsp;</label>
							<div class="col-md-2">
								<Button id="buscar" icon="pi pi-search" style="width:100px;" class="p-button-primary" @click='buscarPlanilla' />
							</div>							
						</div>
					</div>
                </template>
            </Toolbar>
			<DataTable
				v-if="disblePlanilla"
                class="p-datatable-gridlines p-datatable-striped p-datatable-sm p-datatable-responsive p-datatable-customers"
                :value="dataPlanilla"
                :rowHover="true"
                dataKey="id"
                :paginator="true"
                :rows="100"
				:selection.sync="planillaSeleccionado"
                :filters="filters"
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="Mostrar {first} hasta {last} de {totalRecords} Registros">
                <template #header>
                    <div class="table-header">
                        <div class="p-field col-md-2">
							<Button id="firmar" label="Enviar SRI" icon="pi pi-check" style="width:120px;" class="p-button-primary" @click='enviarSeleccionados' />
							<label for="anio" style="margin-left: 20px;">Filtar: </label>
							<Dropdown id="anio" 
								style="width:140px;"
								:filter="false" 
								:options="filtroLista" 
								v-model="filtroSeleccionado"
								@input="cambiaFiltro"
								optionLabel="filtro" 
								dataKey="id"
								placeholder="Seleccionar Filtro">
							</Dropdown>
						</div>
                        <span class="p-input-icon-left">
                            <i class="pi pi-search" />
                            <InputText v-model="filters['global']" placeholder="Buscar..." />
                        </span>
                    </div>
                </template>
                <template #empty> No se encontraron Registros. </template>
                <template #loading> Cargando Registros, por favor espere un momento. </template>
				<Column selectionMode="multiple" headerStyle="width: 3em"></Column>
                <Column field="cedula" header="Cédula" headerStyle="width: 9em;">
                    <template #body="slotProps">
                        <span class="p-column-title"> Cédula:</span>
                        {{ slotProps.data.cedula }}
                    </template>
                </Column>
                <Column field="nombres" header="Nombres">
                    <template #body="slotProps">
                        <span class="p-column-title"> Nombres:</span>
                        <span  :class="'customer-badge'">{{slotProps.data.nombres}} {{slotProps.data.apellidos}} </span>
                    </template>
                </Column>
                <Column field="numeromedidor" header="No. Medidor" headerStyle="width: 7em;">
                    <template #body="slotProps">
                        <span class="p-column-title"> No. Medidor:</span>
                        <span  :class="'customer-badge'">{{ slotProps.data.numeromedidor }} </span>
                    </template>
                </Column>
				<Column field="mes" header="Mes" headerStyle="width: 6em;">
                    <template #body="slotProps">
                        <span class="p-column-title"> Mes:</span>
                        <span  :class="'customer-badge'">{{ slotProps.data.mes }} </span>
                    </template>
                </Column>
				<Column field="anio" header="Año" headerStyle="width: 4em;">
                    <template #body="slotProps">
                        <span class="p-column-title"> Año:</span>
                        <span  :class="'customer-badge'">{{ slotProps.data.anio }} </span>
                    </template>
                </Column>
				<Column field="totalpagar" header="Total" headerStyle="width: 4em;">
                    <template #body="slotProps">
                        <span class="p-column-title"> Total:</span>
                        <span  :class="'customer-badge'">{{ slotProps.data.totalpagar }} </span>
                    </template>
                </Column>
				<Column field="claveacceso" header="Clave de acceso">
                    <template #body="slotProps">
                        <span class="p-column-title text-wrap"> Clave de acceso:</span>
                        <span  :class="'customer-badge wrap-text'">{{ slotProps.data.claveacceso | recortarPalabras }} </span>
                    </template>
                </Column>
				<Column field="lecturatomada" header="Estado" headerStyle="width: 9em;" >
					<template #body="slotProps">
						<span class="p-column-title"> Estado </span>
						<span v-if="slotProps.data.estadoenviado == 'RECIBIDA'" :class="'customer-badge status-1'">{{ slotProps.data.estadoenviado }}</span>
						<span v-else-if="slotProps.data.estadoenviado == 'DEVUELTA'" v-tooltip="'Ver motivo devolucion'" :class="'customer-badge status-0'" style="cursor:pointer;"  @click="verMotivoDevolucion(slotProps.data)">{{ slotProps.data.estadoenviado }}</span>
						<span v-else :class="'customer-badge status-0'">{{ slotProps.data.estadoenviado }}</span>
					</template>
				</Column>
                <Column headerStyle="width: 5em;">
                    <template #body="slotProps">
                        <Button icon="pi pi-pencil" class="p-button-rounded p-button-primary p-mr-2" v-tooltip="'Enviar SRI'" @click="firmarIndividual(slotProps.data)" />
                    </template>
                </Column>
            </DataTable>
        </div>
		<Dialog :visible.sync="mensajeDialog" :style="{ width: '500px' }" header="Detalles" :modal="true" class="p-fluid" :position="position" @hide="hideDialog">
			<div class="col-md-12 p-lg-12">
				<Textarea inputId="textarea" rows="3" cols="30" v-model="motivo" disabled></Textarea>
			</div>
			<template #footer>
				<Button label="Salir" icon="pi pi-times" class="p-button-warning p-mr-2" @click="hideDialog"/>
			</template>
		</Dialog>
	</div>
</template>
<script>
import AnioService from "../../service/administracion/AnioService";
import MesService from "../../service/administracion/MesService";
import PlanillaService from "../../service/administracion/PlanillaService";
import Swal from 'sweetalert2';
import Globals from "../../js/Globales";

export default {
	data() {
		return {
			anioLista: [],
			anioSeleccionado: {},
			mesLista: [],
			mesSeleccionado: {},
			dataPlanilla: [],
            disblePlanilla: false,
			filters: {},
			position: "top",
			rango: Globals[0].paginacion.rango,
			tituloTabla: null,
			planillaSeleccionado: [],
			mensajeDialog: false,
			motivo: null,
			filtroLista: [],
			filtroSeleccionado: {}
		}
	},
	anioService: null,
	mesService: null,
	planillaService: null,
	created() {
		this.anioService = new AnioService();
		this.mesService = new MesService();
		this.planillaService = new PlanillaService();
	},
	mounted() {
		this.cargarAnio();
		this.cargarMes();
		this.cargarFiltro();
	},
	components: {
	},
	methods: {
		cargarFiltro(){
			this.filtroLista.push( { id: 0, filtro: "Todos" } );
			this.filtroLista.push( { id: 1, filtro: "NO ENVIADO" } );
			this.filtroLista.push( { id: 2, filtro: "RECIBIDA" } );
			this.filtroLista.push( { id: 3, filtro: "DEVUELTA" } );
			this.filtroSeleccionado = this.filtroLista[0];
		},
		buscarPlanilla(){
			if(Object.keys(this.anioSeleccionado).length == 0){
                Swal.fire({position: 'top', title: 'Advertencia!', text: "Debe seleccionar año", icon: 'warning', showConfirmButton: true, timer: 6000});
                return;
            }
			if(Object.keys(this.mesSeleccionado).length == 0){
                Swal.fire({position: 'top', title: 'Advertencia!', text: "Debe seleccionar año", icon: 'warning', showConfirmButton: true, timer: 6000});
                return;
            }
			this.filters = {};
			this.dataPlanilla = [];
			this.planillaSeleccionado = [];
			Swal.fire({
				title: 'Cargando...',
				html: 'por favor, espere!...',
				allowOutsideClick: false,
				didOpen: () => {
					Swal.showLoading()
				}
			});
			this.planillaService.consultarplanillafirmada(this.anioSeleccionado.id,this.mesSeleccionado.id).then( response => {
				this.dataPlanilla = response.data;
				this.disblePlanilla = true;
				Swal.close();
			}).catch( err => {
				console.log(err);
				Swal.close();
			});
		},

		cargarAnio(){
			this.anioLista = [];
			this.anioService.buscaractivos().then( response => {
				this.anioLista = response.data;
			}).catch( error => {
				console.log(error);
			});
		},

		cargarMes(){
			this.mesLista = [];
			this.mesService.buscaractivos().then( response => {
				this.mesLista = response.data;
			}).catch( error => {
				console.log(error);
			});
		},

		enviarSeleccionados(){
			if(Object.keys(this.planillaSeleccionado).length == 0){
                Swal.fire({position: 'top', title: 'Advertencia!', text: "Debe seleccionar al menos un registro a firmar", icon: 'warning', showConfirmButton: true, timer: 6000});
                return;
            }
			Swal.fire({ title: 'Advertencia', text: "Enviar SRI \nDesea continuar?", icon: 'warning', showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33', confirmButtonText: 'Si', cancelButtonText: 'Cancelar'
            }).then((result) => {
                if (result.isConfirmed) {
					Swal.fire({
						title: 'Cargando...',
						html: 'por favor, espere!...',
						allowOutsideClick: false,
						didOpen: () => {
							Swal.showLoading()
						}
					});
                    this.planillaService.enviarcomprobante(this.planillaSeleccionado).then( response => {
						if( response.data.estado == "ok" ){
							Swal.close();
							Swal.fire({ position: 'center', title: 'Correcto!', text: "Facturas enviadas correctamente", icon: 'success', showConfirmButton: true, timer: 6000 });
							this.buscarPlanilla();
						}else{
							Swal.close();
							Swal.fire({ position: 'center', title: 'Advertencia!', text: "Error al enviar documentos", icon: 'warning', showConfirmButton: true, timer: 6000 });
						}
					}).catch( error => {
						console.log(error);
						Swal.fire({ position: 'center', title: 'Advertencia!', text: "Error al enviar documentos", icon: 'warning', showConfirmButton: true, timer: 6000 });
					});
                }
            })
		},

		firmarIndividual(data){
			if( data.estadoenviado == "RECIBIDA" ){
				Swal.fire({ position: 'center', title: 'Advertencia!', text: "Comprobante fue enviado", icon: 'warning', showConfirmButton: true, timer: 6000 });
				return;
			}
			if( data.estadoenviado == "DEVUELTA" ){
				Swal.fire({ position: 'center', title: 'Advertencia!', text: "Comprobante fue DEVUELTO", icon: 'warning', showConfirmButton: true, timer: 6000 });
				return;
			}
			let object = [];
			object.push(data);
			Swal.fire({ title: 'Advertencia', text: "Enviar SRI \nDesea continuar?", icon: 'warning', showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33', confirmButtonText: 'Si', cancelButtonText: 'Cancelar'
            }).then((result) => {
                if (result.isConfirmed) {
					Swal.fire({
						title: 'Cargando...',
						html: 'por favor, espere!...',
						allowOutsideClick: false,
						didOpen: () => {
							Swal.showLoading()
						}
					});
                    this.planillaService.enviarcomprobante(object).then( response => {
						Swal.close();
						if( response.data.estado == "ok" ){
							Swal.fire({ position: 'center', title: 'Correcto!', text: "Factura enviada correctamente", icon: 'success', showConfirmButton: true, timer: 6000 });
							this.buscarPlanilla();
							this.planillaSeleccionado = [];
						}else{
							Swal.fire({ position: 'center', title: 'Advertencia!', text: "Error al enviar documento", icon: 'warning', showConfirmButton: true, timer: 6000 });
						}
					}).catch( error => {
						Swal.close();
						console.log(error);
						Swal.fire({ position: 'center', title: 'Advertencia!', text: "Error al enviar documento", icon: 'warning', showConfirmButton: true, timer: 6000 });
					});
                }
            })
		},
		verMotivoDevolucion(data){
			this.motivo = null;
			this.mensajeDialog = true;
			this.motivo = data.mensajerespuestaenvio;
		},
		hideDialog(){
			this.mensajeDialog = false;
		},
		cambiaFiltro(){
			if(Object.keys(this.anioSeleccionado).length == 0){
                Swal.fire({position: 'top', title: 'Advertencia!', text: "Debe seleccionar año", icon: 'warning', showConfirmButton: true, timer: 6000});
                return;
            }
			if(Object.keys(this.mesSeleccionado).length == 0){
                Swal.fire({position: 'top', title: 'Advertencia!', text: "Debe seleccionar año", icon: 'warning', showConfirmButton: true, timer: 6000});
                return;
            }
			this.filters = {};
			this.dataPlanilla = [];
			this.planillaSeleccionado = [];
			Swal.fire({
				title: 'Cargando...',
				html: 'por favor, espere!...',
				allowOutsideClick: false,
				didOpen: () => {
					Swal.showLoading()
				}
			});
			if( this.filtroSeleccionado.id == 0){
				this.planillaService.consultarplanillafirmada(this.anioSeleccionado.id,this.mesSeleccionado.id).then( response => {
					this.dataPlanilla = response.data;
					this.disblePlanilla = true;
					Swal.close();
				}).catch( err => {
					console.log(err);
					Swal.close();
				});
			}else{
				this.planillaService.consultarplanillafirmadaporestado(this.anioSeleccionado.id,this.mesSeleccionado.id, this.filtroSeleccionado.filtro).then( response => {
					this.dataPlanilla = response.data;
					this.disblePlanilla = true;
					Swal.close();
				}).catch( err => {
					console.log(err);
					Swal.close();
				});
			}
		}
	},
	filters: {
		recortarPalabras: function(value) {
            if(value == null || value == undefined) return "";
			let retorno = value.substring(0,16);
            retorno = retorno + "\n" + value.substring(16,32);
			retorno = retorno + "\n" + value.substring(32,value.length);
			//retorno  = value.substring(16,16);
            return retorno;
        },
	}
}
</script>
<style scoped lang="scss">
/deep/ .p-progressbar {
	height: .5rem;
	background-color: #D8DADC;
	.p-progressbar-value {
		background-color: #607D8B;
	}
}
.table-header {
	display: flex;
	justify-content: space-between;
}
/deep/ .p-datatable.p-datatable-customers {
	.p-datatable-header {
		padding: 1rem;
		text-align: left;
		font-size: 1.5rem;
	}
	.p-paginator {
		padding: 1rem;
	}
	.p-datatable-thead > tr > th {
		text-align: left;
	}
	.p-datatable-tbody > tr > td {
		cursor: auto;
	}
	.p-dropdown-label:not(.p-placeholder) {
		text-transform: uppercase;
	}
}
/* Responsive */
.p-datatable-customers .p-datatable-tbody > tr > td .p-column-title {
    display: none;
    
    
}
.customer-badge {
	border-radius: 2px;
	padding: .25em .5rem;
	font-weight: 700;
	font-size: 12px;
	letter-spacing: .3px;
	&.status-qualified {
		background: #C8E6C9;
		color: #256029;
	}
	&.status-0 {
		background: #FFCDD2;
		color: #C63737;
	}
	&.status-negotiation {
		background: #FEEDAF;
		color: #8A5340;
	}
	&.status-1 {
		background: #B3E5FC;
		color: #23547B;
	}
	&.status-renewal {
		background: #ECCFFF;
		color: #694382;
	}
	&.status-proposal {
		background: #FFD8B2;
		color: #805B36;
	}
}
.p-progressbar-value.ui-widget-header {
	background: #607d8b;
}
@media (max-width: 640px) {
	.p-progressbar {
		margin-top: .5rem;
	}
}
.product-image {
	width: 100px;
	box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23)
}
.orders-subtable {
	padding: 1rem;
}
.product-badge {
	border-radius: 2px;
	padding: .25em .5rem;
	text-transform: uppercase;
	font-weight: 700;
	font-size: 12px;
	letter-spacing: .3px;
	&.status-instock {
		background: #C8E6C9;
		color: #256029;
	}
	&.status-outofstock {
		background: #FFCDD2;
		color: #C63737;
	}
	&.status-lowstock {
		background: #FEEDAF;
		color: #8A5340;
	}
}
.order-badge {
	border-radius: 2px;
	padding: .25em .5rem;
	text-transform: uppercase;
	font-weight: 700;
	font-size: 12px;
	letter-spacing: .3px;
	&.order-delivered {
		background: #C8E6C9;
		color: #256029;
	}
	&.order-cancelled {
		background: #FFCDD2;
		color: #C63737;
	}
	&.order-pending {
		background: #FEEDAF;
		color: #8A5340;
	}
	&.order-returned {
		background: #ECCFFF;
		color: #694382;
	}
}

@media screen and (max-width: 960px) {
	/deep/ .p-datatable {
		&.p-datatable-customers {
			.p-datatable-thead > tr > th,
			.p-datatable-tfoot > tr > td {
				display: none !important;
			}
			.p-datatable-tbody > tr {
				> td {
					text-align: left;
					display: block;
					border: 0 none !important;
					width: 100% !important;
					float: left;
					clear: left;
					border: 0 none;
					.p-column-title {
						padding: .4rem;
						min-width: 30%;
						display: inline-block;
						margin: -.4rem 1rem -.4rem -.4rem;
						font-weight: bold;
					}
					.p-progressbar {
						margin-top: .5rem;
					}
				}
			}
		}
	}
}
</style>